<template>
  <div class="custom-menu">
    <div class="name-and-icon-container" data-testid="custom-menu-name-and-icon-container">
      <div class="button-name-container old-globals">
        <label for="buttonName">Button Name</label>
        <md-field>
          <md-input
            id="buttonName"
            :value="customMenu.buttonLabel.en"
            :disabled="readonly"
            :maxlength="30"
            placeholder="Name custom menu"
            aria-label="Custom menu name"
            data-testid="custom-menu-name-input"
            @input="updateButtonLabel"
          />
        </md-field>
      </div>
      <div class="button-icon-container" data-testid="custom-menu-icon-container">
        <label>Icon</label>
        <icon-select
          :selected-key="customMenu.iconKey"
          @update="updateButtonIcon"
        />
      </div>
    </div>
    <div class="editor-container new-globals" data-testid="custom-menus-inputs-container">
      <dialogue-editor
        :settings="editorSettings"
        :items="decoratedItems"
        :readonly="readonly"
        @update="updateMenuItems"
      />
    </div>
  </div>
</template>

<script>
import DialogueEditor from '../questions/DialogueEditor';
import IconSelect from './IconSelect';

export default {
  name: 'custom-menu',
  components: {
    DialogueEditor,
    IconSelect,
  },
  props: {
    customMenu: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editorSettings: {
        type: 'CUSTOM_MENU',
        onText: 'On-at-Start Menus',
        offText: 'Off-at-Start Menus',
        questionLabel: 'Parent Button',
        newQuestionLabel: 'Type here to add a new parent',
        childLabel: 'Child Button',
        newChildLabel: 'Type here to add a new child',
        isAnswerDisabled: true,
        isParentChild: true,
      },
    }
  },
  computed: {
    decoratedItems() {
      const items = this.customMenu.items || []
      return items;
    },
  },
  methods: {
    updateButtonLabel(value) {
      this.$emit('update', {
        ...this.customMenu,
        buttonLabel: {
          en: value
        }
      });
    },
    updateButtonIcon(value) {
      this.$emit('update', {
        ...this.customMenu,
        iconKey: value
      });
    },
    updateMenuItems(value) {
      this.$emit('update', {
        ...this.customMenu,
        items: value
      });
    }
  }
}
</script>

<style scoped>
.custom-menu {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.name-and-icon-container {
  padding-top: 20px;
  display: flex;
}
.button-name-container {
  background-color: inherit;
}
.button-name-container .md-field {
  width: 300px;
  margin-top: 5px;
}
.button-icon-container {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}
.editor-container {
  height: 100%;
  margin-top: 20px;
}
</style>